import * as React from 'react';
import OrganizationSettings from '../models/OrganizationSettings'
import {identity} from '../../core/auth/identityAuth';
import * as moment from 'moment';
import Button from '@material-ui/core/Button';
import Form from '../../shared/components/Form';
import TextField from '@material-ui/core/TextField';
import { Typography, Grid, Menu, MenuItem, Divider, IconButton, FormControl, InputLabel, Select, Chip } from '@material-ui/core';
import Role from '../models/Role';
import EditableChipList from '../../shared/components/EditableChipList';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import Address from '../models/Address';
import { withRouter, RouteComponentProps } from "react-router-dom";
import CountryService from "../../../modules/shared/services/CountryService";
import HttpService from '../../../modules/core/services/HttpService';
import HttpCallConfig from '../../core/models/HttpCallConfig'
import {defaultProvider} from '../../../constants'

const httpService = HttpService.Instance;

const ITEM_HEIGHT = 48;

interface IState {
  assets: any[]
  addressTypes: any[]
  availableRoles: Role[]
  typeMenueElement: HTMLElement | undefined
}

interface IProps extends RouteComponentProps<any> {
  disabled?: boolean
  entityId?: string
  callback?: () => void
}

class OrganisationForm extends React.Component<IProps, IState> {
  public assets: any[] = [];
  public organizationFormComponent: Form
  public hasRoles: boolean

  constructor(props: IProps) {
    super(props);
    this.state = {
      typeMenueElement: undefined,
      assets: [],
      addressTypes: [],
      availableRoles: []
    }
    this.getOrganization = this.getOrganization.bind(this);
    this.saveData = this.saveData.bind(this);
    this.mapAssetData = this.mapAssetData.bind(this);
    this.hasRoles = false;
  }

  public handleCloseAdresTypeMenue = (type?: any) => {
    if (type) {
      const address = new Address();
      address.street = ""
      address.streetNumber = ""
      address.addition = ""
      address.postalCode = ""
      address.city = ""
      address.country = ""
      address.addressTypeId = type.id;
      this.organizationFormComponent.formShadowData.addresses.push(address);
      this.setState({ ...this.state, typeMenueElement: undefined })
    }
    else {
      this.setState({ ...this.state, typeMenueElement: undefined })
    }
  }

  public handleOpenAdresTypeMenue = (event: any) => {
    this.setState({ typeMenueElement: event.currentTarget })
  }

  public mapAssetData(data: OrganizationSettings) {
    const availableRoles = this.state.availableRoles
    const assets: any[] = availableRoles.reduce((acc: any[], item: Role) => {
      if (!acc[0]) {
        acc[0] = {}
      }
      if (!item.assetName && acc[0].hasOwnProperty('Generic')) {
        acc[0].Generic.push(item)
      }
      if (!item.assetName && !acc[0].hasOwnProperty('Generic')) {
        acc[0].Generic = [item]
      }
      if (item.assetName && acc[0].hasOwnProperty(item.assetName)) {
        acc[0][item.assetName].push(item)
      }
      if (item.assetName && !acc[0].hasOwnProperty(item.assetName)) {
        acc[0][item.assetName] = [item]
      }
      return acc;
    }, [{}])
      .reduce((acc: any[], item: any) => {
        Object.keys(item).forEach((k) => {
          acc.push({ name: (k), availableRoles: item[k], roles: [] })
        });
        return acc;
      }, []);
    for (const asset of assets) {
      data.roles.forEach((role: Role) => {
        if (!role.assetName && asset.name === 'Generic') {
          asset.roles.push(role)
        }
        if (role.assetName === asset.name) {
          asset.roles.push(role)
        }
      });
    }
    return assets
  }

  public handleDeleteRole = (role: Role) => {
    this.organizationFormComponent.formShadowData.roles = this.removeByIdAndEnvironment(this.organizationFormComponent.formShadowData.roles, role.environmentId, role.id)
    this.organizationFormComponent.formShadowData.assets = this.mapAssetData(this.organizationFormComponent.formShadowData)
    this.forceUpdate();
  }

  public handleAddRole = (role: Role) => {
    this.organizationFormComponent.formShadowData.roles.push(role);
    this.organizationFormComponent.formShadowData.assets = this.mapAssetData(this.organizationFormComponent.formShadowData)
    this.forceUpdate();
  }

  public getOrganization() {
    if (identity['nxt:entity:id']) {
      let organization = new OrganizationSettings
      return Promise.all([
        httpService.get(process.env.REACT_APP_API_URL + 'addresstypes')
          .then((response: Response) => response.json())
          .then((data: any) => {
            this.setState({ ...this.state, addressTypes: data.addressTypes })
          }),
        httpService.get(process.env.REACT_APP_API_URL + 'entityRoles')
          .then((response: Response) => response.json())
          .then((data: any) => {
            this.setState({ ...this.state, availableRoles: data.entityRoles })
          }),
        httpService.get(process.env.REACT_APP_API_URL + 'entity/' + identity['nxt:entity:id'])
          .then((response: Response) => response.json())
          .then((data: any) => {
            organization = data;
          })
      ])
        .then(() => {
          if (organization) {
            organization.assets = this.mapAssetData(organization)
          }
          return new Promise((resolve) => {
            if (organization) { resolve(organization) }
            else {
              resolve({
                id: '',
                name: '',
                nxtPortId: null,
                addresses: [],
                vat: '',
                duns: '',
                eori: '',
                referralCode: '',
                dateAdded: '',
                roles: [],
                assets: [],
              })
            }
          });
        })
    }
    return null
  }

  public async saveData(data: any) {
    let result = null;
    if (identity['nxt:entity:id']) {
      const httpCallConfig = new HttpCallConfig;
      httpCallConfig.successMessage = 'Organization updated.'
      result = await httpService.put(process.env.REACT_APP_API_URL + 'entity/' + identity['nxt:entity:id'], data, httpCallConfig);
      if(this.props.callback){
        this.props.callback();
      }
    }
    return result;
  }

  public removeAddress(address: Address) {
    this.organizationFormComponent.formShadowData.addresses = this.organizationFormComponent.formShadowData.addresses.filter((item: Address) => item.addressTypeId !== address.addressTypeId)
    this.forceUpdate();
  }

  public addressName(id: number): string | undefined {
    for (const type of this.state.addressTypes) {
      if (type.id === id) {
        return type.name
      }
    }
    return undefined
  }

  public removeByIdAndEnvironment(array: any[], environmentId: any, id: any) {
    let indexOfMatch
    array.map((item, index) => {
      if (item.id === id && item.environmentId === environmentId) {
        indexOfMatch = index;
      }
    })
    if (indexOfMatch !== undefined) { array.splice(indexOfMatch, 1) }
    return array
  }

  public renderEnvironmentRoles(item: any, environmentIds: any, label: string) {
    const roles = item.roles.filter((role: any) => environmentIds.includes(role.environmentId));
    if (!roles.length) {
      return null;
    }

    return (
      <EditableChipList
        items={roles}
        disabled
        itemOptions={item.availableRoles}
        handleAddItem={this.handleAddRole}
        handleDeleteItem={this.handleDeleteRole}
        labelProperty="name"
        label={label}
        disbaleDoubles
      />
    );
  }

  public render() {
    const hasCharacters = (value: string) => value.length <= 0;
    const filteredAddressTypes = this.state.addressTypes.filter(type => {
      if (this.organizationFormComponent && this.organizationFormComponent.formShadowData) {
        for (const address of this.organizationFormComponent.formShadowData.addresses) {
          if (address.addressTypeId === type.id) {
            return false
          }
        }
        return true
      }
      return true
    })
    return (
      <Form
        ref={(ref: Form) => this.organizationFormComponent = ref}
        history={this.props.history}
        saveFormPromise={this.saveData}
        getFormPromise={this.getOrganization}
        refreshHandler={
          (callback?: () => void) => {
            this.forceUpdate(() => {
              if (callback) { callback() }
            })
          }
        }
      >
        {this.organizationFormComponent && this.organizationFormComponent.formShadowData &&
          <div>
            { this.organizationFormComponent.formShadowData.identityProvider !== defaultProvider &&
              <div className="padding-bottom-24">
                <Chip className='full-width' label={"Your organization is linked with external entity provider " + this.organizationFormComponent.formShadowData.identityProvider+". Some functionality is limited."} />
              </div>
            }
            <Grid container={true} spacing={24}>
              <Grid item={true}>
                <TextField
                  required={true}
                  name="name"
                  label="Name"
                  value={this.organizationFormComponent.formShadowData.name}
                  onChange={(e: any) => { this.organizationFormComponent.onChangeHandler(e, { validation: hasCharacters }); }}
                  margin="normal"
                  error={this.organizationFormComponent.formShadowData.name.length <= 0}
                  disabled={this.props.disabled}
                />
              </Grid>
              <Grid item={true}>
                <TextField
                  name="eori"
                  label="EORI"
                  value={this.organizationFormComponent.formShadowData.eori}
                  onChange={(e: any) => { this.organizationFormComponent.onChangeHandler(e); }}
                  margin="normal"
                  disabled={this.props.disabled}
                />
              </Grid>
              <Grid item={true}>
                <TextField
                  name="duns"
                  label="DUNS"
                  value={this.organizationFormComponent.formShadowData.duns}
                  onChange={(e: any) => { this.organizationFormComponent.onChangeHandler(e); }}
                  margin="normal"
                  disabled={this.props.disabled}
                />
              </Grid>
              <Grid item={true}>
                <TextField
                  required={true}
                  name="vat"
                  label="VAT"
                  value={this.organizationFormComponent.formShadowData.vat}
                  onChange={(e: any) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/, '').toUpperCase();
                    this.organizationFormComponent.onChangeHandler(e, { validation: hasCharacters });
                  }}
                  margin="normal"
                  error={this.organizationFormComponent.formShadowData.vat.length <= 0}
                  disabled={true}
                />
              </Grid>
            </Grid>
            <Grid container={true} spacing={24}>
              <Grid item={true}>
                <TextField
                  name="nxtPortId"
                  disabled={true}
                  label="NxtPort ID"
                  value={this.organizationFormComponent.formShadowData.nxtPortId}
                  onChange={(e: any) => { this.organizationFormComponent.onChangeHandler(e); }}
                  margin="normal"
                />
              </Grid>
              <Grid item={true}>
                <TextField
                  name="dateAdded"
                  disabled={true}
                  label="Date Added"
                  value={moment(this.organizationFormComponent.formShadowData.dateAdded).format('YYYY-MM-DD')}
                  onChange={(e: any) => { this.organizationFormComponent.onChangeHandler(e); }}
                  margin="normal"
                />
              </Grid>
            </Grid>
            <Grid container={true} spacing={24} className="padding-bottom-24">
              <Grid item={true}>
                <TextField
                  name="referralCode"
                  disabled={this.props.disabled}
                  label="Referral Code"
                  value={this.organizationFormComponent.formShadowData.referralCode}
                  onChange={(e: any) => { this.organizationFormComponent.onChangeHandler(e); }}
                  margin="normal"
                />
              </Grid>
            </Grid>
            <Divider />
            <div className="padding-bottom-24" />
            {this.organizationFormComponent.formShadowData.assets && this.organizationFormComponent.formShadowData.assets.map((item: any, index: number) => {
              if (item.roles.length) {
                this.hasRoles = true;
                return (
                  <div key={index} className="padding-bottom-24">
                    <Typography variant="subheading" gutterBottom={true}>
                      {item.name + ' roles'}
                    </Typography>
                    {this.renderEnvironmentRoles(item, [0, null, undefined], 'Other')}
                    {this.renderEnvironmentRoles(item, [2], 'Live')}
                    {this.renderEnvironmentRoles(item, [1], 'Sandbox')}
                  </div>
                )
              }
              else {
                return null;
              }
            })}
            {!this.hasRoles &&
              <Typography variant="caption" color="textSecondary" className="padding-bottom-24">No roles available</Typography>
            }
            <Divider />
            <div className="padding-bottom-24" />
            {this.organizationFormComponent.formShadowData.addresses.length < 1 &&
              <Typography variant="caption" color="textSecondary" className="padding-bottom-24">No address added</Typography>
            }
            {this.organizationFormComponent.formShadowData.addresses.map((address: Address, index: number) =>
              <div key={index}>
                <Grid container={true} spacing={8} alignItems="center">
                  <Grid item={true}>
                    <Typography variant="subheading">
                      {this.addressName(address.addressTypeId)} Address
                    </Typography>
                  </Grid>
                  {address.addressTypeId!==1 &&
                    <Grid item={true}>
                      {!this.props.disabled &&
                        <IconButton style={{
                          fontSize: '1.1rem',
                          width: 30,
                          height: 30
                        }}
                          color="default"
                          onClick={() => this.removeAddress(address)}
                        >
                          <DeleteIcon style={{ fontSize: "inherit" }} />
                        </IconButton>
                      }
                    </Grid>
                  }
                </Grid>
                <Grid container={true} spacing={8} className="padding-bottom-24" alignItems='center'>
                  <Grid item xs={12}>
                    <TextField
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="contactName"
                      label="Contact Name"
                      fullWidth
                      value={address.contactName}
                      onChange={(e: any) => {
                        address[e.target.name] = e.target.value
                        this.forceUpdate();
                      }}
                      margin="normal"
                      disabled={this.props.disabled}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="contactEmail"
                      label="Contact Email"
                      fullWidth
                      value={address.contactEmail}
                      onChange={(e: any) => {
                        address[e.target.name] = e.target.value
                        this.forceUpdate();
                      }}
                      margin="normal"
                      disabled={this.props.disabled}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="street"
                      label="Address"
                      fullWidth
                      required
                      multiline
                      rows="3"
                      value={address.street}
                      onChange={(e: any) => {
                        address[e.target.name] = e.target.value
                        this.forceUpdate();
                      }}
                      margin="normal"
                      disabled={this.props.disabled}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      name="postalCode"
                      label="Zip/Postal Code"
                      required
                      value={address.postalCode}
                      onChange={(e: any) => {
                        address[e.target.name] = e.target.value
                        this.forceUpdate();
                      }}
                      margin="normal"
                      disabled={this.props.disabled}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      name="city"
                      label="City"
                      required
                      value={address.city}
                      onChange={(e: any) => {
                        address[e.target.name] = e.target.value
                        this.forceUpdate();
                      }}
                      margin="normal"
                      disabled={this.props.disabled}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl
                      margin="normal"
                      required
                      fullWidth
                    >
                      <InputLabel shrink htmlFor="address.country">Country</InputLabel>
                      <Select
                        disabled={this.props.disabled}
                        name="country"
                        native={true}
                        value={address.country}
                        onChange={(e: any) => {
                          address[e.target.name] = e.target.value
                          this.forceUpdate();
                        }}
                        inputProps={{ name: 'country', id: 'account.country' }} >
                        {(new CountryService()).getCountries().map(item =>
                          <option value={item.code} key={item.code}>{item.name}</option>
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                  {/* <Grid item={true}>
                    <TextField
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="Reference"
                      label="Reference"
                      value={address.reference}
                      onChange={(e: any) => {
                        address[e.target.name] = e.target.value
                        this.forceUpdate();
                      }}
                      margin="normal"
                      disabled={this.props.disabled}
                    />
                  </Grid> */}
                </Grid>
              </div>
            )}
            {filteredAddressTypes.length > 0 && !this.props.disabled &&
              <div className="padding-bottom-24">
                <Button
                  variant='outlined'
                  mini={true}
                  color="secondary"
                  aria-label="Add"
                  onClick={this.handleOpenAdresTypeMenue}
                  aria-owns={this.state.typeMenueElement ? 'long-menu' : undefined}
                  aria-haspopup="true"
                >
                  <AddIcon /> Add address
                </Button>
                <Menu
                  id="long-menu"
                  anchorEl={this.state.typeMenueElement}
                  open={Boolean(this.state.typeMenueElement)}
                  onClose={() => this.handleCloseAdresTypeMenue()}
                  PaperProps={{
                    style: {
                      maxHeight: ITEM_HEIGHT * 4.5,
                      width: 200,
                    },
                  }}
                >
                  {filteredAddressTypes.map((type, index) => (
                    <MenuItem key={index} onClick={() => this.handleCloseAdresTypeMenue(type)}>
                      {type.name}
                    </MenuItem>
                  ))}
                </Menu>
              </div>
            }
            <Divider />
            <div className="padding-bottom-24" />
          </div>
        }
      </Form>
    )
  }
}

export default withRouter(OrganisationForm)


// WEBPACK FOOTER //
// ./src/modules/organization/components/OrganizationForm.tsx